import { STORE_LOGIN_EMAIL } from 'actions/type'

const initialState = {
  email: ''
}

export default ( state = initialState, actions ) => {

  switch ( actions.type ) {
    case STORE_LOGIN_EMAIL:
      return ({
        ...state,
        email: actions.payload
      })
  
    default: return state
  }
}